'use client';

// Libraries
import dynamic from 'next/dynamic';

// Customize
import { LAYOUT, PAGE } from '@/constants/config';
import Loading from '@/components/Loading';

// Variables
const Content = dynamic(() => import('@/components/InternalError/Content'), {
  ssr: false,
  loading: () => <Loading />,
});
const Partners = dynamic(() => import('@/components/Home/Partners'), {
  ssr: false,
  loading: () => <Loading />,
});
const ContactUs = dynamic(() => import('@/components/ContactUs'), {
  ssr: false,
  loading: () => <Loading />,
});

export default function InternalError() {
  return (
    <article className="internal-error">
      <Content />
      <Partners />
      <ContactUs />
    </article>
  );
}

InternalError.layout = LAYOUT.HEADER_NORMAL;
InternalError.canonical =
  [process.env.hostName, PAGE.INTERNAL_ERROR].join('/') + '/';
InternalError.title = 'common.meta.page.internal-error';
InternalError.description = 'content.internal-error.description';
